class TopPosts extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      toggleShowMore: '[data-toggle-show-more]',
    };

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.addEventListener('click', event => {
      if (event.target.closest(this.selectors.toggleShowMore)) {
        event.preventDefault();
        this.classList.toggle('show-more');
        event.target.innerText = this.classList.contains('show-more') ? 'Show less' : 'Show more';
      }
    });
  }
}

customElements.define('top-posts', TopPosts);
